module.exports = __webpack_public_path__ + "assets/position.57f30397.svg";